import { Link } from "react-router-dom";
import { Github, Linkedin } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_eamico-core/artifacts/uowh0b6l_Untitled%20design.png";

const footerCols = [
  {
    title: "Products",
    links: [
      { label: "Eamico Cloud", href: "/cloud" },
      { label: "Pricing", href: "/pricing" },
    ],
  },
  {
    title: "Developers",
    links: [
      { label: "Documentation", href: "/docs" },
      { label: "Community", disabled: true },
      { label: "Changelog", disabled: true },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", href: "/about" },
      { label: "Blog", href: "/blog" },
      { label: "Careers", disabled: true },
      { label: "Investors", href: "https://investordeck.eamico.com", external: true },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Enterprise", disabled: true },
      { label: "Contact Us", disabled: true },
      { label: "Status", href: "#" },
    ],
  },
];

const socials = [
  { icon: Github, label: "github", href: "https://github.com/Eamicodb" },
  { icon: Linkedin, label: "linkedin", href: "https://www.linkedin.com/company/eamico/" },
  { label: "reddit", href: "https://www.reddit.com/r/Eamico/" },
];

const Footer = () => {
  return (
    <footer className="bg-white border-t border-[#e8eaed]" data-testid="footer">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 lg:gap-12">
          {footerCols.map((col) => (
            <div key={col.title}>
              <p className="text-[12px] font-bold text-[#202124] tracking-wide uppercase mb-4">{col.title}</p>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    {link.disabled ? (
                      <span className="text-[13px] text-[#c4c7cc] cursor-default">{link.label}</span>
                    ) : link.external ? (
                      <a href={link.href} target="_blank" rel="noopener noreferrer" className="text-[13px] text-[#5f6368] hover:text-[#202124] transition-colors">
                        {link.label}
                      </a>
                    ) : (
                      <Link to={link.href} className="text-[13px] text-[#5f6368] hover:text-[#202124] transition-colors">
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-[#e8eaed] flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <img src={LOGO_URL} alt="Eamico" className="h-6 w-auto opacity-50" data-testid="footer-logo" />
            <span className="text-[12px] text-[#80868b]">&copy; 2025 Eamico. All rights reserved.</span>
          </div>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="text-[12px] text-[#5f6368] hover:text-[#202124] transition-colors">Privacy</Link>
            <Link to="/terms" className="text-[12px] text-[#5f6368] hover:text-[#202124] transition-colors">Terms</Link>
            <Link to="/cookies" className="text-[12px] text-[#5f6368] hover:text-[#202124] transition-colors">Cookie Policy</Link>
            <Link to="/survey/admin" className="text-[12px] text-[#e8eaed] hover:text-[#80868b] transition-colors" data-testid="footer-admin-link">Admin</Link>
            <div className="flex items-center gap-2 ml-2">
              {socials.map(({ icon: Icon, label, href }) => (
                <a key={label} href={href} target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full flex items-center justify-center text-[#80868b] hover:text-[#202124] hover:bg-[#f1f3f4] transition-all" data-testid={`footer-social-${label}`}>
                  {Icon ? <Icon className="w-4 h-4" /> : label === "reddit" ? (
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M12 0C5.373 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.6.11.793-.26.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z"/></svg>
                  ) : null}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
